// extracted by mini-css-extract-plugin
export default {"icon":"icon_icon__B-0BR"};